import {
  GET_PAGE_BY_ID_SUCCESS,
  GET_WIDGETS,
  GET_WIDGETS_SUCCESS,
  UPDATE_PAGE_SUCCESS,
  RESET_PAGE_PROPS,
  //DICTIONARY
  SET_DICTIONARY_WIDGET_TEMP_NEW_ID,
  CLEAR_DICTIONARY,
  //COMPARISON VALUE SELECTION
  SELECT_COMPARISON_VALUE,
  REMOVE_COMPARISON_VALUE,
  CLEAR_COMPARISON_VALUES,
  //FILTER VALUE SELECTION
  SET_FILTER_VALUE,
  CLEAR_VALUE_FILTER_SELECTED,
  REMOVE_SELECTED_VALUE,
  //PAGE THUMBNAIL
  SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL,
  //WIDGET DATA
  GET_WIDGET_DATA,
  GET_WIDGET_DATA_SUCCESS,
  GET_FIELD_INFOS,
  GET_FIELD_INFOS_SUCCESS,
  CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  // UPLOADS
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS,
  // REQUEST STATUS
  SET_WIDGET_REQUEST_STATUS,
  //OTHER
  SET_LAST_WIDGET_SAVED,
  CHANGE_SAVING_PAGE_STATUS,
  // DRILL DOWN
  SET_DRILLDOWN_ENABLED,
  // AUTO-REFRESH
  BUMP_DATA_REFRESH_TOKEN,
} from "./constants"

export function getPageByIdSuccess(payload) {
  return {
    type: GET_PAGE_BY_ID_SUCCESS,
    payload,
  }
}

export function getWidgetsAction(payload) {
  return {
    type: GET_WIDGETS,
    payload,
  }
}

export function getWidgetsSuccess(payload) {
  return {
    type: GET_WIDGETS_SUCCESS,
    payload,
  }
}

export function updatePageSuccess(payload) {
  return {
    type: UPDATE_PAGE_SUCCESS,
    payload,
  }
}

//DICTIONARY
export function setDictionaryWidgetTempNewId(payload) {
  return {
    type: SET_DICTIONARY_WIDGET_TEMP_NEW_ID,
    payload,
  }
}

export function clearDictionaryAction(payload) {
  return {
    type: CLEAR_DICTIONARY,
    payload,
  }
}

//FILTER VALUE SELECTION
export function selectComparisonValueAction(payload) {
  return {
    type: SELECT_COMPARISON_VALUE,
    payload,
  }
}

export function removeComparisonValueAction(payload) {
  return {
    type: REMOVE_COMPARISON_VALUE,
    payload,
  }
}

export function clearComparisonValuesAction(payload) {
  return {
    type: CLEAR_COMPARISON_VALUES,
    payload,
  }
}

//FILTER VALUE SELECTION
export function setFilterValueAction(payload) {
  return {
    type: SET_FILTER_VALUE,
    payload,
  }
}

export function clearValueFilterSelectedAction(payload) {
  return {
    type: CLEAR_VALUE_FILTER_SELECTED,
    payload,
  }
}

export function removeSelectedValueAction(payload) {
  return {
    type: REMOVE_SELECTED_VALUE,
    payload,
  }
}

//FILTER VALUE SELECTION
export function takeScreenshotAndSaveThumbnailAction(payload) {
  return {
    type: SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL,
    payload,
  }
}

//WIDGET DATA
export function getWidgetDataAction(payload) {
  return {
    type: GET_WIDGET_DATA,
    payload,
  }
}

export function getWidgetDataSuccess(payload) {
  return {
    type: GET_WIDGET_DATA_SUCCESS,
    payload,
  }
}

export function getFieldInfosAction(payload) {
  return {
    type: GET_FIELD_INFOS,
    payload,
  }
}

export function getFieldInfosSuccess(payload) {
  return {
    type: GET_FIELD_INFOS_SUCCESS,
    payload,
  }
}

export function cloneDataFromWidgetBeingEditedAndCleanItAction(payload) {
  return {
    type: CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
    payload,
  }
}

export function cloneDataFromWidgetToWidgetBeingEditedAction(payload) {
  return {
    type: CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
    payload,
  }
}

export function cloneFilterDataFromWidgetBeingEditedAndCleanItAction(payload) {
  return {
    type: CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
    payload,
  }
}

export function cloneFilterDataFromWidgetToWidgetBeingEditedAction(payload) {
  return {
    type: CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
    payload,
  }
}

//PERMISSION
//CLEAR/DELETE FULL PAGE
// UPLOADS
export const uploadWidgetImageStatusActionReset = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET,
  payload,
})

export const uploadWidgetImageStatusActionPending = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING,
  payload,
})

export const uploadWidgetImageStatusActionSuccess = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS,
  payload,
})

// REQUEST STATUS
export const setWidgetRequestStatus = payload => ({
  type: SET_WIDGET_REQUEST_STATUS,
  payload,
})

export const resetPagePropsAction = () => ({
  type: RESET_PAGE_PROPS,
})

export const setLastWidgetSavedAction = payload => ({
  type: SET_LAST_WIDGET_SAVED,
  payload,
})

//SAVING STATUS
export const changeSavingPageStatusAction = payload => ({
  type: CHANGE_SAVING_PAGE_STATUS,
  payload,
})

// DRILL DOWN
export function setDrillDownEnabledAction(payload) {
  return { type: SET_DRILLDOWN_ENABLED, payload }
}

// AUTO-REFRESH
export function bumpDataRefreshTokenAction() {
  return { type: BUMP_DATA_REFRESH_TOKEN }
}
